import React, { Component } from "react";
import Close from "../../../../Icons/Close";
import _ from "lodash";

function jsUpperCaseFirst(string) {
  return string.charAt(0).toUpperCase();
}
export default class LikePost extends Component {
  constructor(props) {
    super(props);
    this.state = {
      postDetails: {},
    };
  }

  render() {
    let arrayPhoto = [];
    return (
      <div
        className="modal show modal-skin"
        id="modalPostLikes"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="modalLikes"
        aria-hidden="true"
        style={{ display: "show", background: "rgba(0, 76, 197, 0.7)" }}
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <form>
              <button
                onClick={this.props.onCloseLikeModal}
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <Close className="img-fluid" alt="" />
              </button>

              <div className="modal-body">
                <section>
                  <h5 className="modal-title mt-0">Ont aimé ce post</h5>
                  {!_.isEmpty(this.props.likes) ? (
                    <ul className="row mx-n2 list-enfants">
                      {this.props.likes.map((item, index) => {
                        let nameUpperCase = jsUpperCaseFirst(item.nom);
                        arrayPhoto.push({
                          backgroundImage: "url(" + item.lienPhoto + ")",
                          backgroundSize: "cover",
                          backgroundRepeat: "no-repeat",
                          backgroundPosition: "center",
                        });
                        return item ? (
                          <li key={index} className="col-md-6 px-2">
                            <label className="rounded15 box-shadow">
                              <span
                                className="avatar"
                                style={arrayPhoto[index]}
                              ></span>
                              <span className="name">
                                {item.prenom + " " + nameUpperCase + "."}
                              </span>
                            </label>
                          </li>
                        ) : (
                          ""
                        );
                      })}
                    </ul>
                  ) : (
                    ""
                  )}
                </section>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}
